export default __webpack_public_path__ + "static/media/car-crash.f7520a85.svg";